export default {
  app: "jida-data-asset",
  ip: "10.42.4.60",
  port: "8719"
}
